import md5 from "md5"

type RegisterBaseInput = {
  password: string
  verifyCode: string
  locale: string
  returnUrl: string
  source: string
}

export type RegisterInput =
  | (RegisterBaseInput & {
      accountType?: "email"
      email: string
      cellphone?: never
    })
  | (RegisterBaseInput & {
      accountType: "phone"
      cellphone: string
      email?: never
    })

export const createRegisterFormData = (values: RegisterInput): FormData => {
  const body = new FormData()
  body.append("user_name", values.accountType === "phone" ? values.cellphone.trim() : values.email.trim())
  body.append("password", md5(values.password))
  body.append("source", values.source)
  body.append("verify_code", values.verifyCode.trim())
  return body
}
